<template>
    <vue-final-modal  v-model="showModal" classes="modal-container" content-class="modalVideo" name="modalYoutube" @before-open="this.beforeOpen()">
        <button class="modal__close" @click="this.closeModal()">
            <svg focusable="false" width="2em" height="2em" viewBox="0 0 24 24">
                <path
                d="M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41z"
                fill="currentColor"
                ></path>
            </svg>    
        </button>
        <iframe ref="IFrameVideo" width="100%" height="348"  title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
    </vue-final-modal>
</template>
<script>

export default {
    name: "ModalYoutube",   
    props:{
        videoLink: String
    },
    data(){
        return {
            showModal: true
        }
    },
    methods:{        
        closeModal(){
            this.$refs.IFrameVideo.src = "";                
            this.$vfm.hide('modalYoutube'); 
        },
        beforeOpen(){           
            this.$refs.IFrameVideo.src = "https://www.youtube.com/embed/" + this.videoLink;            
        }        
    }
}
</script>
<style>
.priceCont{
    cursor:pointer;
}

.modalVideo {
    display: flex;
    flex-direction: column;
    margin: 0 1rem;
    padding: 1rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.25rem;
    background: #fff;  
    width: 100%;
    max-width: 720px;
}

.modal__close {
    position: absolute;
    top: 0.5rem;
    right: 0.5rem; 
}
</style>